import {NgModule, LOCALE_ID, CUSTOM_ELEMENTS_SCHEMA} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {RouteReuseStrategy} from '@angular/router';
import {ServiceWorkerModule} from '@angular/service-worker';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';

import {registerLocaleData} from '@angular/common';
import localeEs from '@angular/common/locales/es';
import {HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi} from '@angular/common/http';

import {IonicModule, IonicRouteStrategy} from '@ionic/angular';

import {environment} from '../environments/environment';
import {InterceptorService} from './services/interceptor.service';
import {ApiService} from './services/api.service';

import {QuillModule} from 'ngx-quill';
import {LazyLoadImageModule} from 'ng-lazyload-image';

import {AppComponent} from './app.component';
import {AppRoutingModule} from './app-routing.module';
import {BuscarComponent} from './componentes/buscar/buscar.component';
import {ProgramacionComponent} from './componentes/programacion/programacion.component';
import {FotoComponent} from './componentes/foto/foto.component';
import {PinpadComponent} from './componentes/pinpad/pinpad.component';
import {InformeComponent} from './componentes/informe/informe.component';
import {AusenciaComponent} from './componentes/ausencia/ausencia.component';
import {FotoNotaComponent} from './componentes/foto-nota/foto-nota.component';
import {NofotosComponent} from './componentes/nofotos/nofotos.component';
import {TextoComponent} from './componentes/texto/texto.component';
import {FechaComponent} from './componentes/fecha/fecha.component';
import {MasivoComponent} from './componentes/masivo/masivo.component';
import {SharedService} from './services/shared.service';
import {ImageCropperComponent} from 'ngx-image-cropper';

registerLocaleData(localeEs);

@NgModule({
  declarations: [
    AppComponent,
    BuscarComponent,
    ProgramacionComponent,
    FotoComponent,
    PinpadComponent,
    InformeComponent,
    AusenciaComponent,
    FotoNotaComponent,
    NofotosComponent,
    TextoComponent,
    FechaComponent,
    MasivoComponent
  ],
  imports: [
    BrowserModule,
    IonicModule.forRoot({
      innerHTMLTemplatesEnabled: true
    }),
    AppRoutingModule,
    QuillModule.forRoot({
      modules: {
        toolbar: [
          ['bold', 'italic', 'underline'],
          [{align: []}],
          [{list: 'ordered'}, {list: 'bullet'}],
          [{color: []}, {background: []}],
          ['link']
        ]
      }
    }),
    ReactiveFormsModule,
    FormsModule,
    LazyLoadImageModule,
    ServiceWorkerModule
      .register('ngsw-worker.js', {
        enabled: environment.production,
        registrationStrategy: 'registerWhenStable:30000'
      }),
    ImageCropperComponent
  ],
  providers: [
    ApiService,
    SharedService,
    {provide: RouteReuseStrategy, useClass: IonicRouteStrategy},
    {provide: HTTP_INTERCEPTORS, useClass: InterceptorService, multi: true},
    {provide: LOCALE_ID, useValue: 'es'},
    provideHttpClient(withInterceptorsFromDi())
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  bootstrap: [AppComponent]
})
export class AppModule {}
